import { get, isNil, isMatch } from 'lodash';
import { combineReducers } from 'redux';
import { createReducer as createPagerReducer } from 'rp-react-pagination';
import { createReducer as createDataTableReducer } from '../modules/DataTable';
import { createExpandableRowReducer } from '../reducers/expandableRow';
import { createReducer as createGridDataTableReducer } from '../reducers/gridDataTable';
import { getInitialRefinement } from '../helpers/shortlistUtils';
import {
    SHORTLIST_REFINEMENT_CHANGE,
    SHORTLIST_REFINEMENT_RESET,
    SHORTLIST_SALE_NAME_REFINEMENT_RESET,
    SHORTLIST_DATA_CHANGE,
    SHORTLIST_FAILURE_LIGHTBOX_OPEN,
    SHORTLIST_FAILURE_LIGHTBOX_CLOSE
} from '../actions/shortlist';

const initialTotalItems = get(window, 'initialData.pagination.totalItems') || 0;

const initialData = {
    totalLots: initialTotalItems,
    lotsFound: initialTotalItems,
    horseNameOptions: [],
    horseSexOptions: [],
    horseAgeOptions: [],
    sireNameOptions: [],
    damNameOptions: [],
    sireOfDamNameOptions: [],
    sellerNameOptions: [],
    buyerDetailOptions: [],
    saleCompanyOptions: [],
    saleNameOptions: [],
    vendorOptions: []
};

const initialRefinement = getInitialRefinement();

function data(state = initialData, action) {
    switch (action.type) {
        case SHORTLIST_DATA_CHANGE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}

function refinement(state = initialRefinement, action) {
    switch (action.type) {
        case SHORTLIST_REFINEMENT_CHANGE:
            return isMatch(state, action.payload)
                ? state
                : Object.assign({}, state, action.payload);
        case SHORTLIST_REFINEMENT_RESET:
            return initialRefinement;
        case SHORTLIST_SALE_NAME_REFINEMENT_RESET:
            return Object.assign({}, state, { sale: initialRefinement.sale });
        default:
            return state;
    }
}

function createRefinementHistoryItems(payload) {
    return Object.keys(payload).map(key => ({
        key,
        value: payload[key]
    }));
}

function refinementHistory(state = [], action) {
    switch (action.type) {
        case SHORTLIST_REFINEMENT_CHANGE: {
            const newItems = createRefinementHistoryItems(action.payload);
            const filteredState = state.filter(
                item => !newItems.find(newItem => (newItem.key === item.key))
            );
            const newNonEmptyItems = newItems.filter(
                newItem => !isNil(newItem.value)
            );
            return [...filteredState, ...newNonEmptyItems];
        }
        case SHORTLIST_REFINEMENT_RESET:
            return [];
        default:
            return state;
    }
}

function shortlistFailureLightbox(state = false, action) {
    switch (action.type) {
        case SHORTLIST_FAILURE_LIGHTBOX_OPEN:
            return true;
        case SHORTLIST_FAILURE_LIGHTBOX_CLOSE:
            return false;
        default:
            return state;
    }
}

export default function createShortlistReducer(stateKey) {
    return combineReducers({
        refinement,
        data,
        dataTable: createDataTableReducer(stateKey, window.initialData || {}),
        gridDataTable: createGridDataTableReducer(stateKey),
        pager: createPagerReducer(stateKey, (window.initialData || {}).pagination),
        expandableRow: createExpandableRowReducer(stateKey),
        refinementHistory,
        shortlistFailureLightbox
    });
}



// WEBPACK FOOTER //
// ./src/js/reducers/shortlist.js